import React, { Component } from 'react'

class Admin extends Component {
  constructor (props) {
    super(props)
    this._mounted = false
  }

  render () {
    return (
      <div></div>
    )
  }
}

export default Admin
